import React, { useEffect } from 'react';
import { useAuth } from 'src/hooks/useAuth';
import { AuthContextProvider } from 'src/providers/AuthContextProvider';
import { PrimaryLayout } from './PrimaryLayout';

export interface PrimaryLayoutWithAuthProps {
  forceSignIn?: boolean;
  children?: React.ReactNode;
  pageTitle: string;
  header: JSX.Element | null;
  footer: JSX.Element | null;
}

const PrimaryLayoutWithAuthInner = ({ forceSignIn = false, header, ...props }: PrimaryLayoutWithAuthProps) => {
  const { vpAuth } = useAuth();
  const isSignedIn = vpAuth?.isSignedIn() ?? false;

  useEffect(() => {
    if (forceSignIn && vpAuth && !isSignedIn) {
      vpAuth.signIn();
    }
  }, [vpAuth, forceSignIn, isSignedIn]);

  return isSignedIn || !forceSignIn ? <PrimaryLayout {...props} header={vpAuth ? header : null} /> : null;
};

/**
 * Initializes auth and optionally forces the customer to sign in before accessing the page
 */
export const PrimaryLayoutWithAuth = ({ ...props }: PrimaryLayoutWithAuthProps) => (
  <AuthContextProvider>
    <PrimaryLayoutWithAuthInner {...props} />
  </AuthContextProvider>
);
